export const types = {
  filterFields: {
    textA: { type: "text", value: "", finder: "" },
    textB: { type: "text", value: "", finder: "" },
    textC: { type: "text", value: "", finder: "" },
    textD: { type: "text", value: "", finder: "" },
    locality: {
      type: "object",
      value: {},
      finder: "",
    },
    role: {
      type: "object",
      value: {},
      finder: "",
    },
    // subLocality: {
    //   type: "array",
    //   value: [],
    //   finder: "",
    // },
    dateA: { type: "date", value: "", finder: "" },
    dateB: { type: "date", value: "", finder: "" },
    dateC: { type: "date", value: "", finder: "" },
    dateD: { type: "date", value: "", finder: "" },
    boolA: {
      type: "boolObject",
      value: null,
      finder: "",
    },
    boolB: {
      type: "boolObject",
      value: null,
      finder: "",
    },
  },
};
